import type { AuthJWT } from '@snowit/types/auth';
import type { PermissionModel, RoleModel } from '@snowit/types/permissions';
import type { UserModel } from '@snowit/types/users';
import type { User, UserInfo } from 'firebase/auth';

import { create } from 'zustand';

export type AuthState = {
  user: User;
  logged: boolean;
  checked: boolean;
  token: string;
  jwt: AuthJWT;
  db?: UserModel;
  roles: RoleModel[];
  permissions: PermissionModel[];
};

type AuthStore = AuthState & {
  setSession: (state: AuthState) => void;
  setDb: (db?: UserModel) => void;
  setRoles: (roles: RoleModel[]) => void;
  setPermissions: (permissions: PermissionModel[]) => void;
  reset: () => void;
};

export const defaultUser = {
  isAnonymous: false,
  uid: '',
  emailVerified: false,
  email: '',
  tenantId: 'snowit',
  displayName: '',
  providerData: [] as UserInfo[],
} as User;

export const defaultAuthState: AuthState = {
  logged: false,
  checked: false,
  user: defaultUser,
  token: '',
  jwt: {},
  db: undefined,
  roles: [],
  permissions: [],
};

export const useAuthStore = create<AuthStore>((set) => ({
  ...defaultAuthState,
  setSession: (state) => set(state),
  setDb: (db) => set({ db }),
  setRoles: (roles) => set({ roles }),
  setPermissions: (permissions) => set({ permissions }),
  reset: () =>
    set({
      ...defaultAuthState,
      checked: true,
      roles: [],
      permissions: [],
    }),
}));
